import { Collapse } from 'antd';
import type { ReactNode } from 'react';
import styles from '../Reports.module.scss';

interface ReportSectionProps {
  sectionKey: string;
  title: string;
  subtitle?: string;
  icon?: ReactNode;
  preview?: string;
  defaultActive?: boolean;
  children: ReactNode;
}

export function ReportSection({
  sectionKey,
  title,
  subtitle,
  icon,
  preview,
  defaultActive = true,
  children,
}: ReportSectionProps) {
  return (
    <Collapse
      bordered={false}
      className={styles.reportSection}
      defaultActiveKey={defaultActive ? [sectionKey] : []}
      items={[
        {
          key: sectionKey,
          label: (
            <div className={styles.sectionHeader}>
              {icon ? <span className={styles.sectionIcon}>{icon}</span> : null}
              <div className={styles.sectionText}>
                <span className={styles.sectionTitle}>{title}</span>
                {subtitle ? <span className={styles.sectionSubtitle}>{subtitle}</span> : null}
              </div>
              {preview ? <span className={styles.sectionPreview}>{preview}</span> : null}
            </div>
          ),
          children: <div className={styles.sectionBody}>{children}</div>,
        },
      ]}
    />
  );
}
